module.exports = __webpack_public_path__ + "assets/icon-openTicket.36f9360a.svg";